import { SVGAttributes } from "react";

export const VersoThemeSpecialIcon = (
  props: SVGAttributes<SVGElement> & { size: "regular" }
) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4a8 8 0 100 16 8 8 0 000-16zm-.204 2.29a5.715 5.715 0 00-5.507 5.506l5.508-5.507zm-4.482 8.982a5.703 5.703 0 01-.592-1.08l7.47-7.47c.383.159.744.358 1.08.592l-7.958 7.957zm9.372-6.544l-7.958 7.958c.336.234.697.433 1.08.593l7.47-7.472a5.701 5.701 0 00-.592-1.079zm1.025 3.475l-5.508 5.508a5.715 5.715 0 005.508-5.508z"
        fill="currentColor"
      />
    </svg>
  );
};
VersoThemeSpecialIcon.displayName = "VersoThemeSpecialIcon";
